import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { getDashboardCount } from "../redux/actions/DashboardActions";
import styled from "styled-components";
import { Row, Col, Card, Table } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import StatisticsWidget from "../../Components/StatisticsWidget";
import { getDashboardList } from "../../redux/actions/DashboardActions";
import './morque.css'
import { getCircleVehicleReportList } from "../../redux/actions/VerifiedReportActions";
import { subDays } from "date-fns";

// IST mein sirf date (yyyy-MM-dd), time nahi

import { getMasterUsertypeCircleReportWiseList,getMasterUsertypeList } from "../../redux/actions/MasterActions";
import { getCancelBookingList } from "../../redux/actions/BookingActions";
import { getDisplayDateTimeFormat } from "../../util/generalUtills";

const Dashboard = () => {
  const tableRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const {
    AuthReducer: { auth, isAuthenticated },
    dashboardReducer: { dashboardLists, loadingDashboard, errorsDashboard },
    verifiedReportReducer: {
      tripReportLists,
      loadingReport,
      errorsReport,
      reportCount,
    },
    bookingReducer: {
      cancelBookingList,
      cancelBookingPermissions,
      loadingBooking,
      errorsBooking,
      cancelBookingCount,
      changedBookingStatus,
    },
    masterReducer: {
      masterUsertypeLists,
      masterUsertypeUserWiseLists,
      loadingMaster,
      errorsMaster,
    },
  } = useSelector((state) => state);

  // Circle usertype buttons list (API: usertype-circle-report)
  const circleUsertypes =
    (masterUsertypeUserWiseLists && masterUsertypeUserWiseLists.length
      ? masterUsertypeUserWiseLists
      : masterUsertypeLists) || [];

  const [userType, setUserType] = useState(null);

  const getISTDateString = (date) =>
    date.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(logout());
      navigate('/login')
    }
  }, [auth]);

  useEffect(() => {
    if (auth?.accessToken) {
      dispatch(getDashboardList(auth?.accessToken));
      dispatch(getCancelBookingList(auth?.accessToken, 5, 1, "", "DESC"));
      dispatch(getMasterUsertypeCircleReportWiseList(auth?.accessToken));
      dispatch(getMasterUsertypeList(auth?.accessToken));
    }
  }, [dispatch, auth]);

  useEffect(() => {
  }, [dashboardLists])

  useEffect(() => {
    // Default: first usertype select jab list load ho jaye (page load pe first button selected)
    if ((userType === undefined || userType === null) && circleUsertypes.length > 0) {
      const firstId = circleUsertypes[0]?.id ?? circleUsertypes[0]?.usertypeId;
      setUserType(firstId);
      return;
    }

    if (auth?.accessToken && userType != null) {
      dispatch(
        getCircleVehicleReportList(
          auth?.accessToken,
          100,
          1,
          "",
          "DESC",
          getISTDateString(subDays(new Date(), 7)),
          getISTDateString(new Date()),
          userType
        )
      );
    }
  }, [userType, circleUsertypes, auth?.accessToken, dispatch]);

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: "Dashboard", path: "/", active: true },
        ]}
        title={"Dashboard"}
      />
      <Row>
        <Col>
          <Card className="border-0 shadow-lg overflow-hidden" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <Card.Body className="py-0">
              <div className="marquee">
                <div className="marquee-track">
                  <div className="marquee-content text-white fw-bold" style={{ fontSize: '1.1rem' }}>
                    <i className="mdi mdi-check-circle me-2"></i>All hydrant valves are working fine..
                  </div>
                  <div className="marquee-content text-white fw-bold" style={{ fontSize: '1.1rem' }}>
                    <i className="mdi mdi-camera-check me-2"></i>Cameras are working fine..
                  </div>
                  <div className="marquee-content text-warning fw-bold" style={{ fontSize: '1.1rem' }}>
                    <i className="mdi mdi-alert-circle me-2"></i>3 Hydrant not working
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="justify-content-center mb-3">
        <Col md={12} xl={12}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-1">
              <h5 className="card-title mb-1 text-center" style={{ fontSize: '0.95rem', fontWeight: '600' }}>
                <i className="mdi mdi-view-dashboard me-1"></i>Water Management Dashboard
              </h5>
              <div className="d-flex flex-wrap gap-1 justify-content-center">
                <Link to={`/Request-For-Open-Valve-Booking`} className="text-decoration-none flex-fill" style={{ minWidth: '135px', maxWidth: '240px' }}>
                  <div className="dashboard-card px-2 py-1 rounded-1 position-relative overflow-hidden d-flex align-items-center"
                    style={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', transition: 'all 0.3s ease', minHeight: '50px' }}>
                    <div className="dashboard-icon me-2" style={{ flexShrink: 0 }}>
                      <i className="mdi mdi-valve-open text-white" style={{ fontSize: '1.5rem', opacity: 0.9 }}></i>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-white" style={{ fontSize: '0.65rem', fontWeight: '400', lineHeight: '1.1', opacity: 0.85 }}>Open Valve</div>
                      <div className="text-white fw-bold" style={{ fontSize: '1.3rem' }}>{dashboardLists?.data?.openValve || 0}</div>
                    </div>
                  </div>
                </Link>
                <Link to={`/On-Going-Booking`} className="text-decoration-none flex-fill" style={{ minWidth: '135px', maxWidth: '240px' }}>
                  <div className="dashboard-card px-2 py-1 rounded-1 position-relative overflow-hidden d-flex align-items-center"
                    style={{ background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', transition: 'all 0.3s ease', minHeight: '50px' }}>
                    <div className="dashboard-icon me-2" style={{ flexShrink: 0 }}>
                      <i className="mdi mdi-truck-delivery text-white" style={{ fontSize: '1.5rem', opacity: 0.9 }}></i>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-white" style={{ fontSize: '0.65rem', fontWeight: '400', lineHeight: '1.1', opacity: 0.85 }}>On Going</div>
                      <div className="text-white fw-bold" style={{ fontSize: '1.3rem' }}>{dashboardLists?.data?.onGoing || 0}</div>
                    </div>
                  </div>
                </Link>
                <Link to={`/Water-Supply-End-Booking`} className="text-decoration-none flex-fill" style={{ minWidth: '135px', maxWidth: '240px' }}>
                  <div className="dashboard-card px-2 py-1 rounded-1 position-relative overflow-hidden d-flex align-items-center"
                    style={{ background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)', transition: 'all 0.3s ease', minHeight: '50px' }}>
                    <div className="dashboard-icon me-2" style={{ flexShrink: 0 }}>
                      <i className="mdi mdi-water-check text-white" style={{ fontSize: '1.5rem', opacity: 0.9 }}></i>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-white" style={{ fontSize: '0.65rem', fontWeight: '400', lineHeight: '1.1', opacity: 0.85 }}>Water Supplied</div>
                      <div className="text-white fw-bold" style={{ fontSize: '1.3rem' }}>{dashboardLists?.data?.waterSupplyEnd || 0}</div>
                    </div>
                  </div>
                </Link>
                <Link to={`/Verification-Pending-Booking`} className="text-decoration-none flex-fill" style={{ minWidth: '135px', maxWidth: '240px' }}>
                  <div className="dashboard-card px-2 py-1 rounded-1 position-relative overflow-hidden d-flex align-items-center"
                    style={{ background: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', transition: 'all 0.3s ease', minHeight: '50px' }}>
                    <div className="dashboard-icon me-2" style={{ flexShrink: 0 }}>
                      <i className="mdi mdi-clock-alert text-white" style={{ fontSize: '1.5rem', opacity: 0.9 }}></i>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-white" style={{ fontSize: '0.65rem', fontWeight: '400', lineHeight: '1.1', opacity: 0.85 }}>Pending Verify</div>
                      <div className="text-white fw-bold" style={{ fontSize: '1.3rem' }}>{dashboardLists?.data?.verificationPending || 0}</div>
                    </div>
                  </div>
                </Link>
                <Link to={`/Partial-Completed-Booking`} className="text-decoration-none flex-fill" style={{ minWidth: '135px', maxWidth: '240px' }}>
                  <div className="dashboard-card px-2 py-1 rounded-1 position-relative overflow-hidden d-flex align-items-center"
                    style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', transition: 'all 0.3s ease', minHeight: '50px' }}>
                    <div className="dashboard-icon me-2" style={{ flexShrink: 0 }}>
                      <i className="mdi mdi-progress-check text-white" style={{ fontSize: '1.5rem', opacity: 0.9 }}></i>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-white" style={{ fontSize: '0.65rem', fontWeight: '400', lineHeight: '1.1', opacity: 0.85 }}>Partial Complete</div>
                      <div className="text-white fw-bold" style={{ fontSize: '1.3rem' }}>{dashboardLists?.data?.partialComplete || 0}</div>
                    </div>
                  </div>
                </Link>
                <Link to={`/Cancel-Booking`} className="text-decoration-none flex-fill" style={{ minWidth: '135px', maxWidth: '240px' }}>
                  <div className="dashboard-card px-2 py-1 rounded-1 position-relative overflow-hidden d-flex align-items-center"
                    style={{ background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)', transition: 'all 0.3s ease', minHeight: '50px' }}>
                    <div className="dashboard-icon me-2" style={{ flexShrink: 0 }}>
                      <i className="mdi mdi-cancel text-white" style={{ fontSize: '1.5rem', opacity: 0.9 }}></i>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-white" style={{ fontSize: '0.65rem', fontWeight: '400', lineHeight: '1.1', opacity: 0.85 }}>Cancelled</div>
                      <div className="text-white fw-bold" style={{ fontSize: '1.3rem' }}>{dashboardLists?.data?.cancelled || 0}</div>
                    </div>
                  </div>
                </Link>
                <Link to={`/Current-Booking`} className="text-decoration-none flex-fill" style={{ minWidth: '135px', maxWidth: '240px' }}>
                  <div className="dashboard-card px-2 py-1 rounded-1 position-relative overflow-hidden d-flex align-items-center"
                    style={{ background: 'linear-gradient(135deg, #74b9ff 0%, #0984e3 100%)', transition: 'all 0.3s ease', minHeight: '50px' }}>
                    <div className="dashboard-icon me-2" style={{ flexShrink: 0 }}>
                      <i className="mdi mdi-format-list-numbered text-white" style={{ fontSize: '1.5rem', opacity: 0.9 }}></i>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-white" style={{ fontSize: '0.65rem', fontWeight: '400', lineHeight: '1.1', opacity: 0.85 }}>Total Bookings</div>
                      <div className="text-white fw-bold" style={{ fontSize: '1.3rem' }}>{dashboardLists?.data?.totalBookings || 0}</div>
                    </div>
                  </div>
                </Link>
                <Link to={`/Vehicle`} className="text-decoration-none flex-fill" style={{ minWidth: '135px', maxWidth: '240px' }}>
                  <div className="dashboard-card px-2 py-1 rounded-1 position-relative overflow-hidden d-flex align-items-center"
                    style={{ background: 'linear-gradient(135deg, #a29bfe 0%, #6c5ce7 100%)', transition: 'all 0.3s ease', minHeight: '50px' }}>
                    <div className="dashboard-icon me-2" style={{ flexShrink: 0 }}>
                      <i className="mdi mdi-truck text-white" style={{ fontSize: '1.5rem', opacity: 0.9 }}></i>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-white" style={{ fontSize: '0.65rem', fontWeight: '400', lineHeight: '1.1', opacity: 0.85 }}>Total Vehicles</div>
                      <div className="text-white fw-bold" style={{ fontSize: '1.3rem' }}>{dashboardLists?.data?.totalVehicles || 0}</div>
                    </div>
                  </div>
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md={12} xl={12}>
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <div className="d-flex align-items-center mb-4">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-sm rounded-circle bg-primary-subtle d-flex align-items-center justify-content-center">
                    <i className="mdi mdi-water text-primary" style={{ fontSize: '1.5rem' }}></i>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h4 className="mb-0">Real-time supply monitoring</h4>
                  <p className="text-muted mb-0">Water Supply Details</p>
                </div>
              </div>
              <Row className="justify-content-center">
                <Col md={12} xl={12}>
                  <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
                    {circleUsertypes?.map((btnItem, index) => (
                      <div key={index} className="flex-grow-1">
                        <button
                          type="button"
                        
                          onClick={() => setUserType(btnItem?.id)}
                          className={`btn w-100 ${userType === btnItem?.id ? 'btn-primary' : 'btn-outline-primary'}`}
                          style={{
                            borderRadius: '25px',
                            fontSize: '0.875rem',
                            fontWeight: '500',
                            transition: 'all 0.3s ease'
                          }}
                        >
                          {btnItem?.name}
                        </button>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
              <div style={{ overflowY: "auto", border: "1px solid #dee2e6" }}>
                <Table
                  ref={tableRef}
                  className="mb-0 table-bordered"
                  size="sm"
                  id="table-to-print"
                  striped
                  responsive
                  style={{ width: "100%" }}
                >
                  <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1 }}>
                    <tr>
                      <th></th>
                      {(() => {
                        const list = tripReportLists?.data || [];
                        const uniqueCircles = [...new Set(list.map((item) => item.circleName))];
                        if (uniqueCircles.length > 0) {
                          return uniqueCircles.map((circleName, index) => (
                            <th key={index} colSpan={3}>{circleName}</th>
                          ));
                        }
                        return null;
                      })()}
                    </tr>
                    <tr>
                      <th>Date</th>
                      {(() => {
                        const list = tripReportLists?.data || [];
                        const uniqueCircles = [...new Set(list.map((item) => item.circleName))];
                        if (uniqueCircles.length > 0) {
                          return uniqueCircles.map((circleName, index) => (
                            <React.Fragment key={index}>
                              <th>Booking</th>
                              <th>Tanker</th>
                              <th>Water (K.L.)</th>
                            </React.Fragment>
                          ));
                        }
                        return (
                          <>
                            <th>Booking</th>
                            <th>Tanker</th>
                            <th>Water (K.L.)</th>
                          </>
                        );
                      })()}
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const list = tripReportLists?.data || [];
                      if (!list.length) {
                        const uniqueCircles = [...new Set(list.map((item) => item.circleName))];
                        const colSpan = uniqueCircles.length > 0 ? uniqueCircles.length * 3 + 1 : 4;
                        return (
                          <tr>
                            <td colSpan={colSpan}>No data found</td>
                          </tr>
                        );
                      }
                      const uniqueCircles = [...new Set(list.map((item) => item.circleName))];
                      const uniqueDates = [...new Set(list.map((item) => item.booking_date))].sort();
                      return uniqueDates.map((date, dateIndex) => (
                        <tr key={dateIndex}>
                          <th>{date}</th>
                          {uniqueCircles.map((circleName, circleIndex) => {
                            const circleData = list.find(
                              (item) => item.booking_date === date && item.circleName === circleName
                            );
                            return (
                              <React.Fragment key={circleIndex}>
                                <td>{circleData?.total_count ?? 0}</td>
                                <td>{circleData?.vehicle_count ?? 0}</td>
                                <td>{parseFloat(circleData?.fillingVolume ?? 0).toFixed(2)}</td>
                              </React.Fragment>
                            );
                          })}
                        </tr>
                      ));
                    })()}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
        {/* <Col md={6} xl={6}>
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <div className="d-flex align-items-center mb-4">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-sm rounded-circle bg-danger-subtle d-flex align-items-center justify-content-center">
                    <i className="mdi mdi-cancel text-danger" style={{ fontSize: '1.5rem' }}></i>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h4 className="mb-0">Recent Cancellations</h4>
                  <p className="text-muted mb-0">Last 5 cancelled bookings</p>
                </div>
              </div>
              <div style={{ maxHeight: "700px", overflowY: "auto", border: "1px solid #dee2e6" }}>
                <Table
                  ref={tableRef}
                  className="mb-0 table-bordered"
                  size="sm"
                  striped
                  responsive
                  id="table-to-print"
                >
                  <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1 }}>
                    <tr>
                      <th>SR No.</th>
                      <th>Job Id</th>
                      <th>Number/Name</th>
                      <th>Booking Time</th>
                      <th>Vehicle</th>
                      <th>Hydrant</th>
                      <th>Drop Location</th>
                      <th>Booked By / Date Time</th>
                      <th>Assigned By / Date</th>
                      <th>Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cancelBookingList.length === 0 ? (
                      <tr>
                        <td colSpan="10">No data found</td>
                      </tr>
                    ) : (
                      cancelBookingList.map((item, index) => (
                        <tr key={item.id}>
                          <td>{item?.bookingId}</td>
                          <td>{item?.name}<br />{item?.mobile}<br />{item?.booking_type}</td>
                          <td>{getDisplayDateTimeFormat(item?.booking_date)}</td>
                          <td>
                            {item?.vehicle_number ? (
                              <>
                                {item?.vehicle_number} <br />{item?.driver_name}<br />{item?.driver_mobile}
                              </>
                            ) : (
                              "Vehicle Not Assign"
                            )}
                          </td>
                          <td>{item?.hydrantName}</td>
                          <td>{item?.destinationName}</td>
                          <td>{item?.createdByBookingDetailsAdminUsers?.name}<br />{getDisplayDateTimeFormat(item?.createdAt)}</td>
                          <td>{item?.createdByBookingDetailsAdminUsers?.name}<br />{getDisplayDateTimeFormat(item?.assign_at)}</td>
                          <td>{item?.cancel_reason}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>

            </Card.Body>
          </Card>
        </Col> */}
      </Row>


    </>
  );
};

export default Dashboard;
